import React, { type ForwardedRef, forwardRef } from 'react';
import ChoiceGroup from '..';
import { type ChoiceGroupProps } from '../types';

// eslint-disable-next-line react/display-name
const ChoiceGroupWithRef = forwardRef<HTMLDivElement, ChoiceGroupProps>((props, ref) => (
  <ChoiceGroup {...props} innerRef={ref} />
)) as unknown as <T>(
  props: ChoiceGroupProps<T> & { ref?: ForwardedRef<HTMLDivElement> }
) => ReturnType<typeof ChoiceGroup>;

export default ChoiceGroupWithRef;
